import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    placeholderMessage: String,
    loadingMessage: String,
    errorMessage: String,
    urlPattern: String
  }

  connect() {

  }

  async load(event) {
    const selectElement = event.target
    const selectedValue = selectElement.value

    if (!selectedValue) {
      this.showPlaceholder()
      return
    }

    this.showLoading()

    try {
      const url = this.urlPatternValue.replace('SELECTED_ID', selectedValue)
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      this.containerTarget.innerHTML = html
    } catch (error) {
      console.error('Error loading dynamic content:', error)
      this.showError()
    }
  }

  showPlaceholder() {
    this.containerTarget.innerHTML = `<div class="placeholder-message">${this.placeholderMessageValue || 'Proszę dokonaj wyboru, aby kontynuować'}</div>`
  }

  showLoading() {
    this.containerTarget.innerHTML = `<div class="loading-message">${this.loadingMessageValue || 'Ładowanie...'}</div>`
  }

  showError() {
    this.containerTarget.innerHTML = `<div class="error-message">${this.errorMessageValue || 'Nie udało się załadować zawartości. Proszę spróbuj ponownie.'}</div>`
  }
}
